// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"d34c20a9","453":"9eb00ecb","490":"1a41b1d9"}[chunkId] + ".chunk.js";
};